<template>
  <modal name="myInfoModifyNotification" v-bind:width="400" v-bind:height="232"
         v-on:before-open="beforeOpen" v-on:before-close="beforeClose">
    <div class="myInfoModifyNotificationWrapper">
      <div class="myInfoModifyNotificationModalHeader">
        <img v-bind:src="closeIcon" v-on:click="modalClose">
      </div>
      <div class="myInfoModifyNotificationModalContent">
        <span>{{line1Text}}<br>{{line2Text}}</span>
      </div>
      <div class="myInfoModifyNotificationModalFooter">
        <button v-on:click="goToMyInfo">프로필완성하기</button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  data () {
    return {
      line1Text: null,
      line2Text: null,
      closeIcon: null,
      type: null,
      isGoToMyInfo: false
    }
  },
  methods: {
    goToMyInfo: function () {
      this.isGoToMyInfo = true
      this.modalClose()
    },
    modalClose: function () {
      this.$modal.hide('myInfoModifyNotification')
    },
    beforeOpen: function (event) {
      // 텍스트 셋팅
      this.type = event.params.type
      this.line1Text = event.params.type === 'init' ? '가입을 환영합니다!' : '프로필이 완성되어야'
      this.line2Text = event.params.type === 'init' ? '프로필을 완성하면 광고올리기가 가능합니다.' : '광고올리기가 가능합니다.'
    },
    beforeClose: function () {
      if(this.type === 'init') {
        // 첫 로그인 시
        if(this.isGoToMyInfo) {
          this.$router.push({ name: 'myInfo' })
        }
      }else{
        // 내정보 미입력시
        if(this.isGoToMyInfo) {
          this.$router.push({ name: 'myInfo' })
        }else {
          this.$router.go(-1)
        }
      }
    }
  },
  created: function () {
    this.closeIcon = require('@/assets/img/modal_close_icon.png')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.myInfoModifyNotificationWrapper{
  display : -webkit-flex;
  display: flex;
  flex-direction: column;
  padding: 0 20px;
}

.myInfoModifyNotificationModalHeader{
  display : -webkit-flex;
  display: flex;
  justify-content: flex-end;
  height: 32px;
}

.myInfoModifyNotificationModalHeader > img {
  cursor: pointer;
  height: 100%;
  width: auto;
}

.myInfoModifyNotificationModalContent {
  text-align: center;
  height: 52px;
  padding: 30px 0 20px 0;
}

.myInfoModifyNotificationModalContent > span {
  font-size: 17px;
}

.myInfoModifyNotificationModalFooter {
  display : -webkit-flex;
  display: flex;
  justify-content: center;
}

.myInfoModifyNotificationModalFooter > button {
  cursor: pointer;
  width: 197px;
  height: 48px;
  background-color: #0099FF;
  color: white;
  font-size: 16px;
  font-weight: bold;
  border: none;
  outline: none;
  border-radius: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/board/elements/myInfoModifyNotificationModal.vue